import { render, staticRenderFns } from "./CompanyTerms.vue?vue&type=template&id=91e25044"
import script from "./CompanyTerms.vue?vue&type=script&lang=js"
export * from "./CompanyTerms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports